import { ScrollViewProps } from '@betty/moonlight';
import {
  AddressVerificationField,
  AddressVerificationState,
} from './AddressVerification.types';

export const FIELDS = Object.values(AddressVerificationField);

export const INITIAL_STATE: AddressVerificationState = {
  building: '',
  street: '',
  unit: '',
  city: '',
  postalCode: '',
};

export const CONTENT_CONTAINER_STYLE: Required<ScrollViewProps>['contentContainerStyle'] =
  {
    gap: 'space-400',
    alignItems: 'center',
    paddingVertical: 'space-400',
    paddingHorizontal: 'space-600',
  };
